const r = (t, e) => `${t}${e ? "-processing" : ""}`;
export {
  r as getButtonAriaLabel
};
//# sourceMappingURL=index.es779.js.map
